import UpdateBgmeaUdAmendment from "../Update";

const ViewBgmeaUdAmendment = (props) => {
  return <UpdateBgmeaUdAmendment {...props} viewMode={true} />;
};

export default ViewBgmeaUdAmendment;
